module.exports = __webpack_public_path__ + "130bd906c9f45d9cd51451fd913cdb47.svg";